module.exports = __webpack_public_path__ + "img/ActivateInstructions.fc22a8a6.png";